import { useSelector } from "react-redux";
import { StateExtended } from "../../interfaces/StateExtended";

export const useAppGameDetailsSelector = () => useSelector((state: StateExtended) => state.event.gameDetails);
export const useAppGroupsSelector = () => useSelector((state: StateExtended) => state.event.groups);
export const useAppRodeoEventsSelector = () => useSelector((state: StateExtended) => state.event.rodeoEvents);
export const useAppPastRodeoEventsSelector = () => useSelector((state: StateExtended) => state.event.pastRodeoEvents);
export const useAppRodeoEventDetailsSelector = () =>
  useSelector((state: StateExtended) => state.event.rodeoEventDetails);
export const useAppPerformancesSelector = () => useSelector((state: StateExtended) => state.event.performances);
export const useAppPerformanceDetailsSelector = () =>
  useSelector((state: StateExtended) => state.event.performanceDetails);
export const useAppEventsSelector = () => useSelector((state: StateExtended) => state.event.events);
export const useAppEventDetailsSelector = () => useSelector((state: StateExtended) => state.event.eventDetails);
export const useAppRidersSelector = () => useSelector((state: StateExtended) => state.event.riders);

export const useAppActivePerformancesSelector = () =>
  useSelector((state: StateExtended) => state.event.activePerformances);

export const useAppCategorizedPerformancesSelector = () =>
  useSelector((state: StateExtended) => state.event.categorizedPerformances);

export const useAppCategorizedRodeoEventsSelector = () =>
  useSelector((state: StateExtended) => state.event.categorizedRodeoEvents);

export const useAppCategorizedEventGroupsSelector = () =>
  useSelector((state: StateExtended) => state.event.categorizedEventGroups);

export const useAppEventGroupsLeaderboardSelector = () =>
  useSelector((state: StateExtended) => state.event.eventGroupsLeaderboard);

export const useAppRodeoLeaderboardSelector = () => useSelector((state: StateExtended) => state.event.rodeoLeaderboard);

export const useAppPerformanceLeaderboardSelector = () =>
  useSelector((state: StateExtended) => state.event.performanceLeaderboard);

export const useAppMakePickModalApiResponseSelector = () =>
  useSelector((state: StateExtended) => state.event.makePickModalApiResponse);

export const useAppViewPicksModalApiResponseSelector = () =>
  useSelector((state: StateExtended) => state.event.viewPicksModalApiResponse);

export const useAppSettingsSelector = () => useSelector((state: StateExtended) => state.global.settings);
export const useSEOSelector = () => useSelector((state: StateExtended) => state.global.seo_list);
export const useAppGameStatusTextSelector = () => useSelector((state: StateExtended) => state.global.game_status_text);
